/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';

import { FieldWrapper, Label, Border, ErrorMessage } from './TextField';

const StyledPhoneInput = styled(InputMask)`
  display: block;
  font-size: 16px;
  width: 100%;
  padding: 6px 6px 6px 0px;
  color: #d4d4d4;
  outline: none;
  border: none;
  background: transparent;

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus {
    border: none;
    -webkit-text-fill-color: #d4d4d4;
    -webkit-box-shadow: none;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

function PhoneField({ name = 'phone', initialValue = '', onChange }) {
  const [phone, setPhone] = useState(initialValue);
  const [focus, setFocus] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (event) => {
    setPhone(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const handleFocus = () => {
    setFocus(true);
  };

  const handleBlur = () => {
    setFocus(false);
  };

  const beforeMaskedValueChange = (newState, oldState, userInput) => {
    let { value, selection } = newState;
    let cursorPosition = selection ? selection.start : null;

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !phone.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--;
        selection = { start: cursorPosition, end: cursorPosition };
      }
      value = value.slice(0, -1);
    }

    return {
      value,
      selection,
    };
  };

  return (
    <FieldWrapper>
      <Label htmlFor="phone" active={focus || Boolean(error)}>
        Phone number
      </Label>
      <StyledPhoneInput
        id="phone"
        type="tel"
        name={name}
        mask="+380 99 999 99 99"
        placeholder="+380"
        maskChar={null}
        value={phone}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        beforeMaskedValueChange={beforeMaskedValueChange}
      />
      <Border className="divider" isFocused={focus} />
      {error && <ErrorMessage>Incorrect phone format</ErrorMessage>}
    </FieldWrapper>
  );
}

export default React.memo(PhoneField);
